import { useState } from 'react';

interface Props {
  company: { id: string; companyName: string; hasLogo: boolean };
  size: 'sm' | 'md' | 'lg';
}

const DIMENSIONS = { sm: 'w-10 h-10', md: 'w-16 h-16', lg: 'w-24 h-24' };
const FONT_SIZE = { sm: 'text-sm', md: 'text-xl', lg: 'text-3xl' };

function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('');
}

export function CompanyLogoOrInitials({ company, size }: Props) {
  const [imgError, setImgError] = useState(false);

  const dim = DIMENSIONS[size];
  const fs = FONT_SIZE[size];
  const initials = getInitials(company.companyName) || '?';

  if (company.hasLogo && !imgError) {
    return (
      <img
        src={`/api/public/company/${company.id}/logo`}
        alt={company.companyName}
        className={`${dim} rounded-xl object-contain bg-white border border-[#DDDDDD] p-1 flex-shrink-0`}
        onError={() => setImgError(true)}
      />
    );
  }

  return (
    <div
      className={`${dim} rounded-xl bg-gradient-to-br from-[#523EF7]/15 to-[#06B6D4]/15 flex items-center justify-center border border-[#DDDDDD] flex-shrink-0`}
    >
      <span className={`${fs} font-bold text-[#523EF7]`}>{initials}</span>
    </div>
  );
}
